import script from "./EditUserInfo.vue?vue&type=script&lang=ts&setup=true"
export * from "./EditUserInfo.vue?vue&type=script&lang=ts&setup=true"

import "./EditUserInfo.vue?vue&type=style&index=0&id=445ad654&lang=css"

const __exports__ = script;

export default __exports__